import { pgEnum, pgTable, timestamp, varchar } from "drizzle-orm/pg-core";
// --- Canonical enums
// Task type keys - single source of truth for valid task types: every workflow a task can have.
// Adding new task types requires a DB migration, but provides database-level validation
export const taskTypeKey = {
    DAMAGE_APPRAISAL: "damage_appraisal",
    COST_ESTIMATE: "cost_estimate",
    INVOICE: "invoice",
    INBOX_PROCESSING: "inbox_processing",
    INCIDENT_REPORT: "incident_report",
};
/** How a task arrived in ePort. Every creation path knows its channel. */
export const taskChannel = {
    EMAIL: "email",
    PDR: "pdr",
    INBOX: "inbox",
    FINN: "finn",
    HARRI: "harri",
    AVD: "avd",
};
/** The part of the operation that handles a task. One value set for all workflows. */
export const department = {
    BREAKDOWN: "breakdown",
    DAMAGE: "damage",
    DAMAGE_SA: "damage_sa",
    DAMAGE_GA: "damage_ga",
    REPAIRS: "repairs",
    FINANCE: "finance",
    CUSTOMER_SUPPORT: "customer_support",
    ADMINISTRATION: "administration",
};
// --- Allowed values per workflow
/** The channels and departments each task type allows. Task and bucket validation read it. */
export const allowedByTaskType = {
    [taskTypeKey.COST_ESTIMATE]: { channels: [taskChannel.EMAIL, taskChannel.PDR], departments: [] },
    [taskTypeKey.DAMAGE_APPRAISAL]: { channels: [taskChannel.EMAIL], departments: [] },
    [taskTypeKey.INVOICE]: { channels: [taskChannel.EMAIL, taskChannel.PDR], departments: [] },
    [taskTypeKey.INBOX_PROCESSING]: {
        channels: [taskChannel.INBOX],
        departments: [
            department.FINANCE,
            department.DAMAGE_SA,
            department.DAMAGE_GA,
            department.BREAKDOWN,
            department.CUSTOMER_SUPPORT,
            department.ADMINISTRATION,
            department.REPAIRS,
        ],
    },
    [taskTypeKey.INCIDENT_REPORT]: {
        channels: [taskChannel.FINN, taskChannel.HARRI, taskChannel.AVD],
        departments: [department.BREAKDOWN, department.DAMAGE],
    },
};
export function isAllowedChannel(taskType, channel) {
    const channels = allowedByTaskType[taskType].channels;
    return channels.includes(channel);
}
export function isAllowedDepartment(taskType, value) {
    const departments = allowedByTaskType[taskType].departments;
    return departments.includes(value);
}
// --- Workflow shape
// Task types whose workflow starts with a Check Step. The shared assign, skip and delete paths
// select on this family.
export const documentTaskTypeKey = {
    DAMAGE_APPRAISAL: taskTypeKey.DAMAGE_APPRAISAL,
    COST_ESTIMATE: taskTypeKey.COST_ESTIMATE,
    INVOICE: taskTypeKey.INVOICE,
};
const documentTaskTypeValues = new Set(Object.values(documentTaskTypeKey));
export function isDocumentTaskType(value) {
    return value != null && documentTaskTypeValues.has(value);
}
// --- Postgres wiring
function enumToPgEnum(myEnum) {
    return Object.values(myEnum);
}
export const taskTypeKeyEnum = pgEnum("task_type_key", enumToPgEnum(taskTypeKey));
export const taskChannelEnum = pgEnum("task_channel", enumToPgEnum(taskChannel));
export const departmentEnum = pgEnum("department", enumToPgEnum(department));
export const taskTypes = pgTable("task_type", {
    // Key IS the primary key - no separate ID needed for lookup tables
    key: taskTypeKeyEnum("key").primaryKey(),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    title: varchar("title", { length: 100 }).notNull(),
    description: varchar("description", { length: 350 }),
});
